import { render, staticRenderFns } from "./CombinedMark.vue?vue&type=template&id=063d1a9c&scoped=true&"
import script from "./CombinedMark.vue?vue&type=script&lang=ts&"
export * from "./CombinedMark.vue?vue&type=script&lang=ts&"
import style0 from "./CombinedMark.vue?vue&type=style&index=0&id=063d1a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d1a9c",
  null
  
)

export default component.exports